// MODALS: a quick add whose form needs data first (every role and seat, every metric, a seat's
// KPI set) opens at once in this state, so the click is answered: "Loading…", then the form; a
// failed read says so and offers Retry; Cancel and Esc close it.
import { Notice, QuickAddDialog } from "@companyos/ui";

export function QuickAddPreparing({
  title,
  failed,
  retry,
  onClose,
}: {
  title: string;
  failed: boolean;
  retry: () => void;
  onClose: () => void;
}) {
  return (
    <QuickAddDialog
      title={title}
      submitLabel="Retry"
      canSubmit={failed}
      onSubmit={retry}
      onClose={onClose}
      slot="quick-add-preparing"
    >
      {failed ? (
        <Notice tone="danger" role="alert" title="Could not load the form">
          Check the connection and retry.
        </Notice>
      ) : (
        <p className="text-sm text-muted-foreground" role="status">
          Loading…
        </p>
      )}
    </QuickAddDialog>
  );
}
